<template>
    <div v-if="isHero && user.profile_image_status == 1" class="hero-image-wrap">
        <img
            v-if="imageUrl"
            :src="imageUrl"
            alt="Profile Image"
            class="hero-img"
        />
        <svg
            v-else
            class="hero-img hero-svg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            role="img"
            aria-label="Default profile avatar"
        >
            <defs>
                <linearGradient
                    id="profileAvatarGradientHero"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="1"
                >
                    <stop offset="0%" stop-color="#A5B4FC" />
                    <stop offset="100%" stop-color="#FBCFE8" />
                </linearGradient>
            </defs>
            <rect width="100" height="100" fill="url(#profileAvatarGradientHero)" />
            <circle cx="50" cy="38" r="16" fill="#FFFFFF" opacity="0.95" />
            <path
                d="M20 74c0-14 15-20 30-20s30 6 30 20v4H20v-4z"
                fill="#FFFFFF"
                opacity="0.95"
            />
        </svg>
        <div class="hero-fade"></div>
        <slot name="overlay"></slot>
    </div>

    <template v-else-if="user.profile_image_status == 1">
        <img
            v-if="imageUrl"
            :src="imageUrl"
            alt="Profile Image"
            class="profile-img"
        />
        <svg
            v-else
            class="profile-img"
            xmlns="http://www.w3.org/2000/svg"
            width="200"
            height="200"
            viewBox="0 0 100 100"
            role="img"
            aria-label="Default profile avatar"
        >
            <defs>
                <linearGradient
                    id="profileAvatarGradientClassic"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="1"
                >
                    <stop offset="0%" stop-color="#A5B4FC" />
                    <stop offset="100%" stop-color="#FBCFE8" />
                </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="48" fill="url(#profileAvatarGradientClassic)" />
            <circle cx="50" cy="38" r="16" fill="#FFFFFF" opacity="0.95" />
            <path
                d="M20 74c0-14 15-20 30-20s30 6 30 20v4H20v-4z"
                fill="#FFFFFF"
                opacity="0.95"
            />
        </svg>
    </template>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    user: { type: Object, required: true },
    fallbackImage: { type: String, default: "" },
});

const isHero = computed(() => props.user.profile_layout === "hero");
const imageUrl = computed(() =>
    props.user.avatar ? props.user.avatar_full_url : props.fallbackImage
);
</script>

<style scoped>
.profile-img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    margin: 0 auto 16px;
}

img.profile-img {
    border: 2px solid var(--userprofile-font-color, #000);
}

.hero-image-wrap {
    position: relative;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 0;
    mask-image: radial-gradient(
        110.26% 100% at 50% 0%,
        #000 50%,
        rgba(0, 0, 0, 0.85) 68.52%,
        rgba(0, 0, 0, 0.48) 81.48%,
        rgba(0, 0, 0, 0) 100%
    );
    -webkit-mask-image: radial-gradient(
        110.26% 100% at 50% 0%,
        #000 50%,
        rgba(0, 0, 0, 0.85) 68.52%,
        rgba(0, 0, 0, 0.48) 81.48%,
        rgba(0, 0, 0, 0) 100%
    );
    mask-size: 100% 100%;
    -webkit-mask-size: 100% 100%;
    mask-repeat: no-repeat;
    -webkit-mask-repeat: no-repeat;
}

.hero-image-wrap::after {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.08) 0%,
        rgba(0, 0, 0, 0.12) 35%,
        rgba(0, 0, 0, 0.18) 100%
    );
}

.hero-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    aspect-ratio: 1 / 1;
}

.hero-svg {
    height: auto;
}

.hero-fade {
    display: none;
}
</style>
